import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HostService {
  private _host: string = '';

  get host(): string {
    return this._host;
  }

  set host(value: string) {
    this._host = value;
  }
}
